import React from "react";
import { connect } from "react-redux";
import compose from "recompose/compose";
import { db } from "firebase/fbConfig.js";
import axios from 'axios'

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import Style from "assets/jss/material-dashboard-pro-react/views/actionsStyle";

import AllOrders from "./AllOrders";
import AllTrucks from "../../views/Maps/AllTrucks";

class Principles extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isTest: false,
      disableGroups: false,
    }
  }

  loadGroups = (uid) => {
    console.log("loading groups");
    db.collection("TEST-users")
      .doc(uid)
      .collection('haney-groups')
      .get()
      .then(
        (snapshot) => {
          const newData = snapshot.docs.map(doc => doc.id);
          return newData;
        },
        (error) => {
          console.log("error fetching data: ", error);
        }
      )
      .then((newData) => {
        this.setState({
          groupsData: newData,
          groupsDataLoaded: true,
        });
      });
  };

  handleSwitchChange = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
  };

  setIsAllOrders = (name) => (event) => {
    console.log("setIsAllOrders")
    this.setState({ isAllOrders: true });
  };

  loadKeepTruckin = () => {
    this.setState({
      ktLoaded: true
    })
    console.log("loadingKt")
    let vehicles = []
    let url = `https://safe-brook-14632.herokuapp.com/https://api.keeptruckin.com/v1/vehicle_locations?vehicle_ids=&per_page=100&page_no=1`
    axios.get(
      url,
      {
        "headers": {
          "x-api-key": "f91ab8bc-ba2b-4a43-8fd9-721469b51e22"
        }
      }
    ).then((response) => {
      // add truck location to accumulator
      console.log(response.data.vehicles)
      //   const location = response.data.vehicles[0].vehicle.current_location
      //   let truck = {
      //     truckLocation: {
      //       lat: location.lat,
      //       lng: location.lon
      //     }
      //   }
      Array.prototype.push.apply(vehicles, response.data.vehicles);

      let url = `https://safe-brook-14632.herokuapp.com/https://api.keeptruckin.com/v1/vehicle_locations?vehicle_ids=&per_page=100&page_no=2`
      axios.get(
        url,
        {
          "headers": {
            "x-api-key": "f91ab8bc-ba2b-4a43-8fd9-721469b51e22"
          }
        }
      ).then((response) => {
        // add truck location to accumulator
        // console.log(response.data.vehicles)
        //   const location = response.data.vehicles[0].vehicle.current_location
        //   let truck = {
        //     truckLocation: {
        //       lat: location.lat,
        //       lng: location.lon
        //     }
        //   }
        Array.prototype.push.apply(vehicles, response.data.vehicles);
        let url = `https://safe-brook-14632.herokuapp.com/https://api.keeptruckin.com/v1/vehicle_locations?vehicle_ids=&per_page=100&page_no=3`
        axios.get(
          url,
          {
            "headers": {
              "x-api-key": "f91ab8bc-ba2b-4a43-8fd9-721469b51e22"
            }
          }
        ).then((response) => {
          // add truck location to accumulator
          // console.log(response.data.vehicles)
          //   const location = response.data.vehicles[0].vehicle.current_location
          //   let truck = {
          //     truckLocation: {
          //       lat: location.lat,
          //       lng: location.lon
          //     }
          //   }
          Array.prototype.push.apply(vehicles, response.data.vehicles);
          // console.log(vehicles)
          this.setState({
            vehicles: vehicles,
            vehiclesReady: true
          })


        })
          .catch((error) => {
            console.log(error)
          })

      })
        .catch((error) => {
          console.log(error)
        })

    })
      .catch((error) => {
        console.log(error)
      })

  }


  filterVehicles = () => {
    // console.log("filtering vehicles")
    var filteredVehicles = this.state.vehicles.filter(function (el) {
      // console.log(el.vehicle)
      return el.vehicle.current_location != null
    }
    )
    // console.log(filteredVehicles)

    this.setState({
      filteredVehicles: filteredVehicles,
      filterVehiclesLoaded: true
    })
  }

  render() {
    const {
      classes,
      authUser,
    } = this.props;

    if (authUser) {
      if (!this.state.groupsDataLoaded) {
        this.loadGroups(authUser.uid);
      }
    }

    if (!this.state.ktLoaded) {
      this.loadKeepTruckin()
    }

    if (this.state.vehiclesReady && !this.state.filterVehiclesLoaded) {
      this.filterVehicles()
    }

    console.log(this.state);
    console.log(this.props);

    return this.state.groupsDataLoaded ? (
      <div>
                {this.state.filteredVehicles &&
          <AllTrucks vehicles={this.state.filteredVehicles} />
        }
        <GridContainer>
          <GridItem xs={7}>
            <b>Disable Groups:</b>
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.disableGroups}
                  onChange={this.handleSwitchChange("disableGroups")}
                  value="disableGroups"
                  classes={{
                    switchBase: classes.switchBase,
                    checked: classes.switchChecked,
                    icon: classes.switchIcon,
                    iconChecked: classes.switchIconChecked,
                    bar: classes.switchBar,
                  }}
                />
              }
              classes={{
                label: classes.label,
              }}
              style={{ marginLeft: "10px" }}
            />
          </GridItem>
          <GridItem xs={5}>
            <b>Test:</b>
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.isTest}
                  onChange={this.handleSwitchChange("isTest")}
                  value="isTest"
                  classes={{
                    switchBase: classes.switchBase,
                    checked: classes.switchChecked,
                    icon: classes.switchIcon,
                    iconChecked: classes.switchIconChecked,
                    bar: classes.switchBar,
                  }}
                />
              }
              classes={{
                label: classes.label,
              }}
              style={{ marginLeft: "10px" }}
            />
          </GridItem>
        </GridContainer>
        {console.log(this.state.isAllOrders)}
        <AllOrders
          groups={this.state.groupsData}
          disableGroups={this.state.disableGroups}
          isTest={this.state.isTest}
          setIsAllOrders={this.setIsAllOrders()}
          isAllOrders={this.state.isAllOrders}
        />
      </div>
    ) : (
      <p className={classes.body}>Loading...</p>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authUser: state.auth.user,
  };
};

export default compose(
  connect(
    mapStateToProps,
  ),
  withStyles(Style)
)(Principles);



// WEBPACK FOOTER //
// ./src/views/Dispatch/AllOrdersParent.jsx